export type Site = {
  code: string;
  name: string;
};

export const getRegionForSiteId = (siteId: string) => regionBySiteId.get(siteId) ?? null;

export const getSiteForSiteId = (siteId: string) => siteById.get(siteId) ?? null;

export const getRegionForPartner = (partner: { siteId?: string }) =>
  partner.siteId ? getRegionForSiteId(partner.siteId) : null;

export const getSiteForPartner = (partner: { siteId?: string }) =>
  partner.siteId ? getSiteForSiteId(partner.siteId) : null;

const allRegions = [
  {
    region: 'Mitt',
    sites: [
      { code: '10468', name: 'Hallstahammar' },
      { code: '12955', name: 'Eskilstuna' },
      { code: '10457', name: 'Karlskoga' },
      { code: '13060', name: 'Örebro FA' },
      { code: '10460', name: 'Örebro' },
      { code: '10450', name: 'Linköping' },
      { code: '10451', name: 'Norrköping' },
      { code: '10453', name: 'Skänninge' },
      { code: '10440', name: 'Åmål' },
      { code: '10461', name: 'Trafo' },
      { code: '10464', name: 'Arvika' },
      { code: '24163', name: 'Karlstad' },
    ],
  },
  {
    region: 'Nedre Norr',
    sites: [
      { code: '10469', name: 'Gävle' },
      { code: '10471', name: 'Bollnäs' },
      { code: '24166', name: 'Borlänge' },
      { code: '24169', name: 'Gävle' },
      { code: '24172', name: 'Hudiksvall' },
      { code: '10474', name: 'Östersund' },
      { code: '10475', name: 'Örnsköldsvik' },
      { code: '10477', name: 'Timrå' },
    ],
  },
  {
    region: 'Stockholm',
    sites: [
      { code: '10452', name: 'Högservice' },
      { code: '10454', name: 'Nyköping' },
      { code: '10466', name: 'Södertälje' },
      { code: '104D1', name: 'Veddesta' },
      { code: '104D3', name: 'Enskede' },
      { code: '104H6', name: 'Huddinge' },
      { code: '130R3', name: 'Stockholm bygg' },
      { code: '40163', name: 'Åkeri Stockholm' },
      { code: '40164', name: 'Älvsjö' },
      { code: '40165', name: 'Rosersberg' },
    ],
  },
  {
    region: 'Syd',
    sites: [
      { code: '10425', name: 'Eslöv' },
      { code: '10431', name: 'Åstorp' },
      { code: '10432', name: 'Halmstad JM' },
      { code: '104H1', name: 'Helsingborg' },
      { code: '104H2', name: 'SR Bjuv Förbehand.' },
      { code: '12914', name: 'Åkeri Malmö Styckeg.' },
      { code: '12926', name: 'Malmö' },
      { code: '130R5', name: 'Rivningar Syd' },
      { code: '24126', name: 'SR Malmö Sturkögatan' },
      { code: '24127', name: 'Tomelilla' },
      { code: '24130', name: 'Halmstad Hamn' },
      { code: '24132', name: 'Halmstad RP' },
      { code: '24135', name: 'Varberg' },
      { code: '30121', name: 'Malmö' },
      { code: '30221', name: 'Halmstad' },
      { code: '40126', name: 'Åkeri Malmö' },
    ],
  },
  {
    region: 'Sydost',
    sites: [
      { code: '10441', name: 'Jönköping JM' },
      { code: '10442', name: 'Värnamo' },
      { code: '104V3', name: 'Vetlanda' },
      { code: '24142', name: 'Jönköping RP' },
      { code: '10421', name: 'Kalmar' },
      { code: '10446', name: 'Oskarshamn' },
      { code: '10449', name: 'Västervik' },
      { code: '10459', name: 'Nybro panna' },
      { code: '12949', name: 'Nybro' },
      { code: '13049', name: 'Vimmerby' },
      { code: '10424', name: 'Karlshamn' },
      { code: '10443', name: 'Ljungby' },
      { code: '104K1', name: 'Karlskrona' },
      { code: '24128', name: 'Kristianstad' },
      { code: '24148', name: 'Växjö' },
    ],
  },
  {
    region: 'Väst',
    sites: [
      { code: '10436', name: 'Tingstad' },
      { code: '104G1', name: 'Göteborg Sugbilar' },
      { code: '13037', name: 'Stenungsund' },
      { code: '10422', name: 'Skövde' },
      { code: '10444', name: 'Lidköping' },
      { code: '24139', name: 'Skara' },
      { code: '10437', name: 'Uddevalla' },
      { code: '10438', name: 'Borås' },
      { code: '10439', name: 'Trollhättan' },
    ],
  },
  {
    region: 'Övre Norr',
    sites: [
      { code: '10489', name: 'Piteå' },
      { code: '10491', name: 'Luleå' },
      { code: '10493', name: 'Kiruna' },
      { code: '10494', name: 'Kiruna JM' },
      { code: '12991', name: 'Luleå FA' },
      { code: '10476', name: 'Umeå' },
      { code: '10488', name: 'Skellefteå' },
      { code: '10498', name: 'Umeå AR' },
      { code: '10499', name: 'Skellefteå AR' },
      { code: '104R8', name: 'Skellefteå Northvolt' },
      { code: '12976', name: 'Umeå FA' },
    ],
  },
];

const regionBySiteId = new Map<string, string>();

const siteById = new Map<string, { code: string; name: string }>();

allRegions.forEach((region) => {
  region.sites.forEach((site) => {
    regionBySiteId.set(site.code, region.region);
    siteById.set(site.code, { code: site.code, name: site.name });
  });
});
